import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";
import { orderByPropertyName } from "../util/orderBy";

export default function referentieReducer(state = initialState.referentie, action) {
	switch (action.type) {
		case types.REFERENCES_LOADED: {
			let referenceData = {};

			Object.keys(action.body).forEach(key => {
				const referenceDataList = Object.keys(action.body[key]).map(k => {
					const volgorde = action.body[key][k].volgorde;
					return {
						value: key === "landen" ? action.body[key][k].landCode : key === "doelgroepen" ? action.body[key][k].id : (action.body[key][k].type ? action.body[key][k].type : action.body[key][k].id),
						label: action.body[key][k].useTypeAsLabel ? action.body[key][k].type ? action.body[key][k].type : action.body[key][k].id : action.body[key][k].naam,
						order: volgorde ? volgorde : 0
					};
				});

				referenceData[key] = orderByPropertyName(referenceDataList, 'order');
			});

			let gemeenten = [];
			let postcodes = [];
			let postcodeGemeenten = [];

			action.body.zoekDeelGemeenten.forEach(zdg => {
				if (!gemeenten.find(x => x.label === zdg.naam))
					gemeenten.push({
						value: zdg.naam,
						label: zdg.naam,
						order: 0,
						nisCode: zdg.nisCode
					});

				if (!postcodes.find(x => x.label === zdg.postcode))
					postcodes.push({
						value: zdg.postcode,
						label: zdg.postcode,
						order: 0,
						nisCode: zdg.nisCode
					});

				if (!postcodeGemeenten.find(x => x.customValue.postcode === zdg.postcode && x.customValue.gemeente === zdg.naam))
					postcodeGemeenten.push({
						value: zdg.postcode + ' - ' + zdg.naam,
						label: zdg.postcode + ' - ' + zdg.naam,
						customValue: {
							postcode: zdg.postcode,
							gemeente: zdg.naam,
							nisCode: zdg.nisCode
						},
						order: 0,
					});
			});

			let locaties = [];
			action.body.locaties.forEach(l => {
				if (!locaties.find(x => x.label === l.naam))
					locaties.push({
						value: l.id,
						label: l.naam,
						order: 0
					});
			});

			referenceData.niveauInstanties.forEach(item => {
				item.niveauEnum = action.body.niveauInstanties.find(e => e.id === item.value).niveauEnum;
			});


			let beschrCorrespAdressen = [];
			action.body.beschrCorrespAdressen.forEach(a => {
				beschrCorrespAdressen.push({
					naam: a.naam,
					descr: a.descr,
					beschrCorrespAdrEnum: a.beschrCorrespAdrEnum,
					volgorde: a.volgorde,
					id: a.id
				});
			});

			let niveausPerOrganisatie = [];
			action.body.niveausPerOrganisatie.forEach(niv => {
				niveausPerOrganisatie.push({
					orgType: niv.orgTypEnum,
					value: niv.niveauEnum,
					label: action.body.niveaus.find(x => x.type === niv.niveauEnum).naam
				});
			});

			//these org types can be selected to be parent of a sportclub
			referenceData.orgTypesForSportclubParent = referenceData.organisatieTypes.filter(item => item.value !== 2 && item.value !== 15);

			referenceData['locaties'] = orderByPropertyName(locaties, 'label');

			referenceData['gemeenten'] = orderByPropertyName(gemeenten, 'label');
			referenceData['postcodes'] = orderByPropertyName(postcodes, 'label');
			referenceData['postcodeGemeenten'] = orderByPropertyName(postcodeGemeenten, 'label');
			referenceData['beschrCorrespAdressen'] = orderByPropertyName(beschrCorrespAdressen, 'volgorde');

			referenceData['niveausPerOrganisatie'] = niveausPerOrganisatie;

			return mergeDeep({}, referenceData);
		}

		default:
			return state;
	}
}
